import React from 'react';
import { Share2, MessageSquare, ThumbsUp, MoreHorizontal } from 'lucide-react';
export function ArticleContent() {
  return <article className="w-full max-w-3xl mx-auto pt-2 pb-12" data-id="element-10">
      {/* Header */}
      <header className="mb-5" data-id="element-11">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight mb-3 tracking-tight" data-id="element-12">
          Say Goodbye to ChatGPT HEYLLOYD Will Soon Take Over Your Laptop
        </h1>

        <div className="flex items-center text-sm text-gray-500 mb-4" data-id="element-13">
          <span className="font-medium text-gray-700" data-id="element-14">By Staff Writer</span>
          <span className="mx-2 text-gray-300" data-id="element-15">•</span>
          <time data-id="element-16">Just now</time>
        </div>

        {/* Action Bar */}
        <div className="flex items-center gap-3 mb-6 border-y border-gray-100 py-2.5" data-id="element-17">
          <button className="flex items-center gap-1.5 text-gray-600 hover:text-blue-600 transition-colors text-sm font-medium" data-id="element-18">
            <ThumbsUp className="w-4 h-4" data-id="element-19" />
            <span data-id="element-20">Like</span>
          </button>
          <button className="flex items-center gap-1.5 text-gray-600 hover:text-blue-600 transition-colors text-sm font-medium" data-id="element-21">
            <MessageSquare className="w-4 h-4" data-id="element-22" />
            <span data-id="element-23">Comment</span>
          </button>
          <button className="flex items-center gap-1.5 text-gray-600 hover:text-blue-600 transition-colors text-sm font-medium ml-auto" data-id="element-24">
            <Share2 className="w-4 h-4" data-id="element-25" />
            <span data-id="element-26">Share</span>
          </button>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-27">
            <MoreHorizontal className="w-4 h-4" data-id="element-28" />
          </button>
        </div>
      </header>

      {/* Hero Image */}
      <figure className="mb-6" data-id="element-29">
        <div className="aspect-[16/10] w-full bg-red-50 overflow-hidden relative shadow-sm" data-id="element-30">
          <img src="https://cdn.magicpatterns.com/uploads/3oFLTXXPbehgPJWRxztxBf/hl_screen_3.png" alt="Laptop showing HEYLLOYD AI interface" className="w-full h-full object-cover" data-id="element-31" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none" data-id="element-32"></div>
        </div>
        <figcaption className="mt-2 text-xs text-gray-500 text-center" data-id="element-33">
          HEYLLOYD AI interface on laptop
        </figcaption>
      </figure>

      {/* Article Body */}
      <div className="prose prose-base max-w-none text-gray-800" data-id="element-34">
        <p className="mb-4 leading-relaxed text-[15px]" data-id="element-35">
          A new generation of AI is emerging and it's not just another chatbot.
        </p>

        <p className="mb-4 leading-relaxed text-[15px]" data-id="element-36">
          As Apple accelerates its push into the Apple Intelligence era, AI is
          moving beyond simple conversations and into real execution. One of the
          most talked-about newcomers is{' '}
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-37">
            HEYLLOYD
          </a>
          , an AI app designed to operate as an intelligent layer across your
          entire laptop.
        </p>

        <p className="mb-4 leading-relaxed text-[15px]" data-id="element-38">
          ChatGPT changed how people interact with AI through text. But it was
          never built to understand ongoing context, manage workflows, or
          actively assist across apps and files.{' '}
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-39">
            HEYLLOYD
          </a>{' '}
          is.
        </p>

        <p className="mb-4 leading-relaxed text-[15px]" data-id="element-40">
          Rather than living in a browser tab,{' '}
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-41">
            HEYLLOYD
          </a>{' '}
          is positioning itself as an always-on intelligence one that
          understands what you're working on, remembers intent, and helps users
          plan, decide, and execute in real time.
        </p>

        <p className="mb-4 leading-relaxed text-[15px]" data-id="element-42">
          What's catching even more attention is the positioning.{' '}
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-43">
            HEYLLOYD
          </a>{' '}
          is currently priced at $7 per month, a fraction of the $24/month many
          users now pay for ChatGPT Pro, while aiming to replace it entirely by
          handling real work not just answers.
        </p>

        <div className="my-6 p-4 bg-blue-50 rounded-lg border-l-4 border-blue-500" data-id="element-44">
          <h3 className="text-base font-bold text-blue-900 mb-2" data-id="element-45">
            Key Differences
          </h3>
          <ul className="list-disc list-inside space-y-1.5 text-blue-800 text-[15px]" data-id="element-46">
            <li data-id="element-47">Always-on intelligence across your entire laptop</li>
            <li data-id="element-48">Understands ongoing context and workflow</li>
            <li data-id="element-49">Proactive assistance without constant prompts</li>
          </ul>
        </div>

        <p className="mb-4 leading-relaxed text-[15px]" data-id="element-50">
          With Apple Intelligence integrating AI more deeply into macOS and iOS,
          apps like{' '}
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-51">
            HEYLLOYD
          </a>{' '}
          are perfectly timed. Instead of replacing Apple's ecosystem,{' '}
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-52">
            HEYLLOYD
          </a>{' '}
          enhances it acting as the thinking layer that connects tools, surfaces
          insights, and reduces friction across daily work.
        </p>

        <p className="mb-4 leading-relaxed text-[15px]" data-id="element-53">
          Early previews suggest{' '}
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-54">
            HEYLLOYD
          </a>{' '}
          won't just answer questions. It will help organize information,
          automate decisions, and assist users proactively without the constant
          back-and-forth prompting traditional chatbots require.
        </p>

        <p className="mb-4 leading-relaxed text-[15px]" data-id="element-55">
          ChatGPT won't disappear overnight. But as AI shifts from conversation
          to execution, tools like{' '}
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-56">
            HEYLLOYD
          </a>{' '}
          especially ones challenging both the function and price of incumbents
          may define what the next phase of personal computing actually looks
          like.
        </p>
      </div>

      {/* Tags */}
      <div className="mt-8 flex flex-wrap gap-2" data-id="element-57">
        {['HEYLLOYD', 'AI', 'Apple Intelligence', 'Tech News', 'Productivity'].map(tag => <span key={tag} className="px-2.5 py-1 bg-gray-100 text-gray-600 text-xs rounded-full hover:bg-gray-200 cursor-pointer transition-colors" data-id="element-58">
            #{tag}
          </span>)}
      </div>

      {/* CTA Section */}
      <div className="mt-10 p-6 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl border border-blue-100 shadow-sm" data-id="element-59">
        <div className="text-center" data-id="element-60">
          <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2" data-id="element-61">
            Get HEYLLOYD Before Prices Increase
          </h3>
          <p className="text-sm md:text-base text-gray-700 mb-4 max-w-xl mx-auto" data-id="element-62">
            Lock in the introductory price of just{' '}
            <span className="font-bold text-blue-600" data-id="element-63">$7/month</span> before it
            goes up. Join early adopters experiencing the future of AI-powered
            productivity.
          </p>
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="inline-block px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors shadow-md hover:shadow-lg" data-id="element-64">
            Get Started Now
          </a>
          <p className="text-xs text-gray-500 mt-3" data-id="element-65">
            Limited time introductory pricing
          </p>
        </div>
      </div>

      {/* Facebook-Style Comments Section - Mobile Only */}
      <div className="md:hidden mt-8 border-t border-gray-200 pt-6" data-id="element-66">
        <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-67">Comments</h3>

        <div className="space-y-4" data-id="element-68">
          {/* Comment 1 */}
          <div className="flex gap-2" data-id="element-69">
            <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="Sarah Chen" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-70" />
            <div className="flex-1" data-id="element-71">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-72">
                <p className="font-semibold text-sm" data-id="element-73">Sarah Chen</p>
                <p className="text-sm text-gray-800" data-id="element-74">
                  Just signed up! This is exactly what I've been looking for.
                  ChatGPT was getting too expensive 💸
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-75">
                <span data-id="element-76">👍 24</span>
                <span data-id="element-77">❤️ 8</span>
                <span data-id="element-78">2h</span>
              </div>
            </div>
          </div>

          {/* Comment 2 with reply */}
          <div className="flex gap-2" data-id="element-79">
            <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Mike Johnson" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-80" />
            <div className="flex-1" data-id="element-81">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-82">
                <p className="font-semibold text-sm" data-id="element-83">Mike Johnson</p>
                <p className="text-sm text-gray-800" data-id="element-84">
                  Wait, $7/month vs $24 for ChatGPT Pro? That's insane value 🔥
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-85">
                <span data-id="element-86">👍 42</span>
                <span data-id="element-87">😮 15</span>
                <span data-id="element-88">3h</span>
              </div>

              {/* Reply */}
              <div className="flex gap-2 mt-3 ml-6" data-id="element-89">
                <img src="https://randomuser.me/api/portraits/women/68.jpg" alt="Emma Davis" className="w-7 h-7 rounded-full flex-shrink-0" data-id="element-90" />
                <div className="flex-1" data-id="element-91">
                  <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-92">
                    <p className="font-semibold text-xs" data-id="element-93">Emma Davis</p>
                    <p className="text-xs text-gray-800" data-id="element-94">
                      Right?! Already switched and loving it
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-95">
                    <span data-id="element-96">👍 12</span>
                    <span data-id="element-97">1h</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Comment 3 */}
          <div className="flex gap-2" data-id="element-98">
            <img src="https://randomuser.me/api/portraits/men/22.jpg" alt="Alex Rodriguez" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-99" />
            <div className="flex-1" data-id="element-100">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-101">
                <p className="font-semibold text-sm" data-id="element-102">Alex Rodriguez</p>
                <p className="text-sm text-gray-800" data-id="element-103">
                  Been using it for a week. It actually understands what I'm
                  working on without me having to explain everything 👏
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-104">
                <span data-id="element-105">👍 38</span>
                <span data-id="element-106">❤️ 12</span>
                <span data-id="element-107">4h</span>
              </div>
            </div>
          </div>

          {/* Comment 4 */}
          <div className="flex gap-2" data-id="element-108">
            <img src="https://randomuser.me/api/portraits/women/12.jpg" alt="Jessica Lee" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-109" />
            <div className="flex-1" data-id="element-110">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-111">
                <p className="font-semibold text-sm" data-id="element-112">Jessica Lee</p>
                <p className="text-sm text-gray-800" data-id="element-113">
                  This is a game changer for productivity. No more switching
                  between tabs!
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-114">
                <span data-id="element-115">👍 29</span>
                <span data-id="element-116">5h</span>
              </div>
            </div>
          </div>

          {/* Comment 5 with replies */}
          <div className="flex gap-2" data-id="element-117">
            <img src="https://randomuser.me/api/portraits/men/46.jpg" alt="David Kim" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-118" />
            <div className="flex-1" data-id="element-119">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-120">
                <p className="font-semibold text-sm" data-id="element-121">David Kim</p>
                <p className="text-sm text-gray-800" data-id="element-122">
                  Does it work on Windows too or just Mac?
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-123">
                <span data-id="element-124">👍 8</span>
                <span data-id="element-125">6h</span>
              </div>

              {/* Reply */}
              <div className="flex gap-2 mt-3 ml-6" data-id="element-126">
                <img src="https://randomuser.me/api/portraits/women/27.jpg" alt="Rachel Park" className="w-7 h-7 rounded-full flex-shrink-0" data-id="element-127" />
                <div className="flex-1" data-id="element-128">
                  <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-129">
                    <p className="font-semibold text-xs" data-id="element-130">Rachel Park</p>
                    <p className="text-xs text-gray-800" data-id="element-131">
                      Works on both! Using it on Windows right now
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-132">
                    <span data-id="element-133">👍 18</span>
                    <span data-id="element-134">5h</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Comment 6 */}
          <div className="flex gap-2" data-id="element-135">
            <img src="https://randomuser.me/api/portraits/men/54.jpg" alt="Tom Wilson" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-136" />
            <div className="flex-1" data-id="element-137">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-138">
                <p className="font-semibold text-sm" data-id="element-139">Tom Wilson</p>
                <p className="text-sm text-gray-800" data-id="element-140">
                  Finally cancelled my ChatGPT subscription. HEYLLOYD does
                  everything I need and more 🎯
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-141">
                <span data-id="element-142">👍 51</span>
                <span data-id="element-143">❤️ 19</span>
                <span data-id="element-144">7h</span>
              </div>
            </div>
          </div>

          {/* Comment 7 */}
          <div className="flex gap-2" data-id="element-145">
            <img src="https://randomuser.me/api/portraits/women/33.jpg" alt="Lisa Martinez" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-146" />
            <div className="flex-1" data-id="element-147">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-148">
                <p className="font-semibold text-sm" data-id="element-149">Lisa Martinez</p>
                <p className="text-sm text-gray-800" data-id="element-150">
                  The context awareness is incredible. It knows what I'm working
                  on without me telling it!
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-151">
                <span data-id="element-152">👍 33</span>
                <span data-id="element-153">😮 9</span>
                <span data-id="element-154">8h</span>
              </div>
            </div>
          </div>

          {/* Comment 8 */}
          <div className="flex gap-2" data-id="element-155">
            <img src="https://randomuser.me/api/portraits/men/71.jpg" alt="James Brown" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-156" />
            <div className="flex-1" data-id="element-157">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-158">
                <p className="font-semibold text-sm" data-id="element-159">James Brown</p>
                <p className="text-sm text-gray-800" data-id="element-160">
                  Best $7 I've spent this month. Seriously impressed 💯
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-161">
                <span data-id="element-162">👍 44</span>
                <span data-id="element-163">❤️ 16</span>
                <span data-id="element-164">9h</span>
              </div>
            </div>
          </div>

          {/* Comment 9 with reply */}
          <div className="flex gap-2" data-id="element-165">
            <img src="https://randomuser.me/api/portraits/women/50.jpg" alt="Nina Patel" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-166" />
            <div className="flex-1" data-id="element-167">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-168">
                <p className="font-semibold text-sm" data-id="element-169">Nina Patel</p>
                <p className="text-sm text-gray-800" data-id="element-170">
                  How is this only $7? The value is insane compared to other AI
                  tools
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-171">
                <span data-id="element-172">👍 37</span>
                <span data-id="element-173">10h</span>
              </div>

              {/* Reply */}
              <div className="flex gap-2 mt-3 ml-6" data-id="element-174">
                <img src="https://randomuser.me/api/portraits/men/18.jpg" alt="Chris Taylor" className="w-7 h-7 rounded-full flex-shrink-0" data-id="element-175" />
                <div className="flex-1" data-id="element-176">
                  <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-177">
                    <p className="font-semibold text-xs" data-id="element-178">Chris Taylor</p>
                    <p className="text-xs text-gray-800" data-id="element-179">
                      Introductory pricing! Get it before it goes up
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-180">
                    <span data-id="element-181">👍 22</span>
                    <span data-id="element-182">9h</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Comment 10 */}
          <div className="flex gap-2" data-id="element-183">
            <img src="https://randomuser.me/api/portraits/men/63.jpg" alt="Kevin Zhang" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-184" />
            <div className="flex-1" data-id="element-185">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-186">
                <p className="font-semibold text-sm" data-id="element-187">Kevin Zhang</p>
                <p className="text-sm text-gray-800" data-id="element-188">
                  Using this for coding and it's amazing. Understands my entire
                  project 🚀
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-189">
                <span data-id="element-190">👍 48</span>
                <span data-id="element-191">❤️ 14</span>
                <span data-id="element-192">11h</span>
              </div>
            </div>
          </div>

          {/* Comment 11 */}
          <div className="flex gap-2" data-id="element-193">
            <img src="https://randomuser.me/api/portraits/women/19.jpg" alt="Amanda White" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-194" />
            <div className="flex-1" data-id="element-195">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-196">
                <p className="font-semibold text-sm" data-id="element-197">Amanda White</p>
                <p className="text-sm text-gray-800" data-id="element-198">
                  This is what AI should have been from the start. So much
                  better than chatbots!
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-199">
                <span data-id="element-200">👍 41</span>
                <span data-id="element-201">12h</span>
              </div>
            </div>
          </div>

          {/* Comment 12 */}
          <div className="flex gap-2" data-id="element-202">
            <img src="https://randomuser.me/api/portraits/men/41.jpg" alt="Ryan Cooper" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-203" />
            <div className="flex-1" data-id="element-204">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-205">
                <p className="font-semibold text-sm" data-id="element-206">Ryan Cooper</p>
                <p className="text-sm text-gray-800" data-id="element-207">
                  Productivity has literally doubled since I started using this
                  ⚡
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-208">
                <span data-id="element-209">👍 35</span>
                <span data-id="element-210">❤️ 11</span>
                <span data-id="element-211">13h</span>
              </div>
            </div>
          </div>

          {/* Comment 13 with reply */}
          <div className="flex gap-2" data-id="element-212">
            <img src="https://randomuser.me/api/portraits/women/65.jpg" alt="Sophia Garcia" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-213" />
            <div className="flex-1" data-id="element-214">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-215">
                <p className="font-semibold text-sm" data-id="element-216">Sophia Garcia</p>
                <p className="text-sm text-gray-800" data-id="element-217">
                  Anyone else feel like this is the future of computing? 🤯
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-218">
                <span data-id="element-219">👍 56</span>
                <span data-id="element-220">😮 21</span>
                <span data-id="element-221">14h</span>
              </div>

              {/* Reply */}
              <div className="flex gap-2 mt-3 ml-6" data-id="element-222">
                <img src="https://randomuser.me/api/portraits/men/29.jpg" alt="Mark Anderson" className="w-7 h-7 rounded-full flex-shrink-0" data-id="element-223" />
                <div className="flex-1" data-id="element-224">
                  <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-225">
                    <p className="font-semibold text-xs" data-id="element-226">Mark Anderson</p>
                    <p className="text-xs text-gray-800" data-id="element-227">
                      100%. This is what Apple Intelligence should be
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-228">
                    <span data-id="element-229">👍 28</span>
                    <span data-id="element-230">13h</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Comment 14 */}
          <div className="flex gap-2" data-id="element-231">
            <img src="https://randomuser.me/api/portraits/men/75.jpg" alt="Daniel Moore" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-232" />
            <div className="flex-1" data-id="element-233">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-234">
                <p className="font-semibold text-sm" data-id="element-235">Daniel Moore</p>
                <p className="text-sm text-gray-800" data-id="element-236">
                  Just tried it and wow... this is next level AI assistance
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-237">
                <span data-id="element-238">👍 39</span>
                <span data-id="element-239">15h</span>
              </div>
            </div>
          </div>

          {/* Comment 15 */}
          <div className="flex gap-2" data-id="element-240">
            <img src="https://randomuser.me/api/portraits/women/8.jpg" alt="Emily Turner" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-241" />
            <div className="flex-1" data-id="element-242">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-243">
                <p className="font-semibold text-sm" data-id="element-244">Emily Turner</p>
                <p className="text-sm text-gray-800" data-id="element-245">
                  The way it remembers context across sessions is incredible. No
                  more repeating myself!
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-246">
                <span data-id="element-247">👍 43</span>
                <span data-id="element-248">❤️ 13</span>
                <span data-id="element-249">16h</span>
              </div>
            </div>
          </div>

          {/* Comment 16 */}
          <div className="flex gap-2" data-id="element-250">
            <img src="https://randomuser.me/api/portraits/men/52.jpg" alt="Brian Scott" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-251" />
            <div className="flex-1" data-id="element-252">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-253">
                <p className="font-semibold text-sm" data-id="element-254">Brian Scott</p>
                <p className="text-sm text-gray-800" data-id="element-255">
                  Switched from ChatGPT and not looking back. This is so much
                  better!
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-256">
                <span data-id="element-257">👍 47</span>
                <span data-id="element-258">17h</span>
              </div>
            </div>
          </div>

          {/* Comment 17 with reply */}
          <div className="flex gap-2" data-id="element-259">
            <img src="https://randomuser.me/api/portraits/women/42.jpg" alt="Michelle Adams" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-260" />
            <div className="flex-1" data-id="element-261">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-262">
                <p className="font-semibold text-sm" data-id="element-263">Michelle Adams</p>
                <p className="text-sm text-gray-800" data-id="element-264">
                  Is there a free trial? Want to test it out first
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-265">
                <span data-id="element-266">👍 15</span>
                <span data-id="element-267">18h</span>
              </div>

              {/* Reply */}
              <div className="flex gap-2 mt-3 ml-6" data-id="element-268">
                <img src="https://randomuser.me/api/portraits/men/36.jpg" alt="Tyler Green" className="w-7 h-7 rounded-full flex-shrink-0" data-id="element-269" />
                <div className="flex-1" data-id="element-270">
                  <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-271">
                    <p className="font-semibold text-xs" data-id="element-272">Tyler Green</p>
                    <p className="text-xs text-gray-800" data-id="element-273">
                      At $7 just try it for a month, totally worth it
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-274">
                    <span data-id="element-275">👍 24</span>
                    <span data-id="element-276">17h</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Comment 18 */}
          <div className="flex gap-2" data-id="element-277">
            <img src="https://randomuser.me/api/portraits/women/71.jpg" alt="Lauren Hill" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-278" />
            <div className="flex-1" data-id="element-279">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-280">
                <p className="font-semibold text-sm" data-id="element-281">Lauren Hill</p>
                <p className="text-sm text-gray-800" data-id="element-282">
                  This is a ChatGPT killer. Way more useful for actual work 💪
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-283">
                <span data-id="element-284">👍 52</span>
                <span data-id="element-285">❤️ 18</span>
                <span data-id="element-286">19h</span>
              </div>
            </div>
          </div>

          {/* Comment 19 */}
          <div className="flex gap-2" data-id="element-287">
            <img src="https://randomuser.me/api/portraits/men/67.jpg" alt="Jason Wright" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-288" />
            <div className="flex-1" data-id="element-289">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-290">
                <p className="font-semibold text-sm" data-id="element-291">Jason Wright</p>
                <p className="text-sm text-gray-800" data-id="element-292">
                  The proactive suggestions are mind-blowing. It anticipates
                  what I need!
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-293">
                <span data-id="element-294">👍 36</span>
                <span data-id="element-295">😮 12</span>
                <span data-id="element-296">20h</span>
              </div>
            </div>
          </div>

          {/* Comment 20 */}
          <div className="flex gap-2" data-id="element-297">
            <img src="https://randomuser.me/api/portraits/women/24.jpg" alt="Victoria Bell" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-298" />
            <div className="flex-1" data-id="element-299">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-300">
                <p className="font-semibold text-sm" data-id="element-301">Victoria Bell</p>
                <p className="text-sm text-gray-800" data-id="element-302">
                  Perfect timing with Apple Intelligence. These two together are
                  🔥
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-303">
                <span data-id="element-304">👍 31</span>
                <span data-id="element-305">1d</span>
              </div>
            </div>
          </div>

          {/* Comment 21 */}
          <div className="flex gap-2" data-id="element-306">
            <img src="https://randomuser.me/api/portraits/men/44.jpg" alt="Steven Clark" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-307" />
            <div className="flex-1" data-id="element-308">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-309">
                <p className="font-semibold text-sm" data-id="element-310">Steven Clark</p>
                <p className="text-sm text-gray-800" data-id="element-311">
                  Been waiting for something like this. AI that actually helps
                  instead of just answering questions
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-312">
                <span data-id="element-313">👍 45</span>
                <span data-id="element-314">❤️ 15</span>
                <span data-id="element-315">1d</span>
              </div>
            </div>
          </div>

          {/* Comment 22 with reply */}
          <div className="flex gap-2" data-id="element-316">
            <img src="https://randomuser.me/api/portraits/women/56.jpg" alt="Hannah Lewis" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-317" />
            <div className="flex-1" data-id="element-318">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-319">
                <p className="font-semibold text-sm" data-id="element-320">Hannah Lewis</p>
                <p className="text-sm text-gray-800" data-id="element-321">
                  Does it integrate with Google Workspace?
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-322">
                <span data-id="element-323">👍 9</span>
                <span data-id="element-324">1d</span>
              </div>

              {/* Reply */}
              <div className="flex gap-2 mt-3 ml-6" data-id="element-325">
                <img src="https://randomuser.me/api/portraits/men/58.jpg" alt="Paul Young" className="w-7 h-7 rounded-full flex-shrink-0" data-id="element-326" />
                <div className="flex-1" data-id="element-327">
                  <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-328">
                    <p className="font-semibold text-xs" data-id="element-329">Paul Young</p>
                    <p className="text-xs text-gray-800" data-id="element-330">
                      Yes! Works great with Google Docs and Gmail
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-331">
                    <span data-id="element-332">👍 16</span>
                    <span data-id="element-333">1d</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Comment 23 */}
          <div className="flex gap-2" data-id="element-334">
            <img src="https://randomuser.me/api/portraits/men/79.jpg" alt="Andrew King" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-335" />
            <div className="flex-1" data-id="element-336">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-337">
                <p className="font-semibold text-sm" data-id="element-338">Andrew King</p>
                <p className="text-sm text-gray-800" data-id="element-339">
                  This is revolutionary. Finally an AI that works WITH me, not
                  just for me
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-340">
                <span data-id="element-341">👍 49</span>
                <span data-id="element-342">❤️ 17</span>
                <span data-id="element-343">1d</span>
              </div>
            </div>
          </div>

          {/* Comment 24 */}
          <div className="flex gap-2" data-id="element-344">
            <img src="https://randomuser.me/api/portraits/women/38.jpg" alt="Megan Hall" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-345" />
            <div className="flex-1" data-id="element-346">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-347">
                <p className="font-semibold text-sm" data-id="element-348">Megan Hall</p>
                <p className="text-sm text-gray-800" data-id="element-349">
                  The multi-app awareness is insane. It sees everything I'm
                  working on! 🤯
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-350">
                <span data-id="element-351">👍 38</span>
                <span data-id="element-352">😮 14</span>
                <span data-id="element-353">1d</span>
              </div>
            </div>
          </div>

          {/* Comment 25 */}
          <div className="flex gap-2" data-id="element-354">
            <img src="https://randomuser.me/api/portraits/men/15.jpg" alt="Robert Allen" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-355" />
            <div className="flex-1" data-id="element-356">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-357">
                <p className="font-semibold text-sm" data-id="element-358">Robert Allen</p>
                <p className="text-sm text-gray-800" data-id="element-359">
                  Best AI purchase I've made. Saves me hours every day ⏰
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-360">
                <span data-id="element-361">👍 42</span>
                <span data-id="element-362">❤️ 16</span>
                <span data-id="element-363">2d</span>
              </div>
            </div>
          </div>

          {/* Comment 26 */}
          <div className="flex gap-2" data-id="element-364">
            <img src="https://randomuser.me/api/portraits/women/62.jpg" alt="Jennifer Baker" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-365" />
            <div className="flex-1" data-id="element-366">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-367">
                <p className="font-semibold text-sm" data-id="element-368">Jennifer Baker</p>
                <p className="text-sm text-gray-800" data-id="element-369">
                  ChatGPT who? This is the real deal 😎
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-370">
                <span data-id="element-371">👍 54</span>
                <span data-id="element-372">2d</span>
              </div>
            </div>
          </div>

          {/* Comment 27 with reply */}
          <div className="flex gap-2" data-id="element-373">
            <img src="https://randomuser.me/api/portraits/men/25.jpg" alt="Matthew Nelson" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-374" />
            <div className="flex-1" data-id="element-375">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-376">
                <p className="font-semibold text-sm" data-id="element-377">Matthew Nelson</p>
                <p className="text-sm text-gray-800" data-id="element-378">
                  How secure is it? Does it store my data?
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-379">
                <span data-id="element-380">👍 11</span>
                <span data-id="element-381">2d</span>
              </div>

              {/* Reply */}
              <div className="flex gap-2 mt-3 ml-6" data-id="element-382">
                <img src="https://randomuser.me/api/portraits/women/47.jpg" alt="Karen Mitchell" className="w-7 h-7 rounded-full flex-shrink-0" data-id="element-383" />
                <div className="flex-1" data-id="element-384">
                  <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-385">
                    <p className="font-semibold text-xs" data-id="element-386">Karen Mitchell</p>
                    <p className="text-xs text-gray-800" data-id="element-387">
                      Everything is encrypted and stored locally. Very secure!
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-388">
                    <span data-id="element-389">👍 19</span>
                    <span data-id="element-390">2d</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Comment 28 */}
          <div className="flex gap-2" data-id="element-391">
            <img src="https://randomuser.me/api/portraits/men/83.jpg" alt="Christopher Carter" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-392" />
            <div className="flex-1" data-id="element-393">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-394">
                <p className="font-semibold text-sm" data-id="element-395">Christopher Carter</p>
                <p className="text-sm text-gray-800" data-id="element-396">
                  This is what I imagined AI would be like. Finally here! 🎉
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-397">
                <span data-id="element-398">👍 46</span>
                <span data-id="element-399">❤️ 13</span>
                <span data-id="element-400">2d</span>
              </div>
            </div>
          </div>

          {/* Comment 29 */}
          <div className="flex gap-2" data-id="element-401">
            <img src="https://randomuser.me/api/portraits/women/14.jpg" alt="Ashley Roberts" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-402" />
            <div className="flex-1" data-id="element-403">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-404">
                <p className="font-semibold text-sm" data-id="element-405">Ashley Roberts</p>
                <p className="text-sm text-gray-800" data-id="element-406">
                  Using it for research and writing. Absolutely game-changing 📚
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-407">
                <span data-id="element-408">👍 34</span>
                <span data-id="element-409">2d</span>
              </div>
            </div>
          </div>

          {/* Comment 30 */}
          <div className="flex gap-2" data-id="element-410">
            <img src="https://randomuser.me/api/portraits/men/91.jpg" alt="Joshua Phillips" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-411" />
            <div className="flex-1" data-id="element-412">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-413">
                <p className="font-semibold text-sm" data-id="element-414">Joshua Phillips</p>
                <p className="text-sm text-gray-800" data-id="element-415">
                  The workflow automation alone is worth way more than $7 🚀
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-416">
                <span data-id="element-417">👍 50</span>
                <span data-id="element-418">❤️ 19</span>
                <span data-id="element-419">2d</span>
              </div>
            </div>
          </div>

          {/* Comment 31 */}
          <div className="flex gap-2" data-id="element-420">
            <img src="https://randomuser.me/api/portraits/women/76.jpg" alt="Samantha Evans" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-421" />
            <div className="flex-1" data-id="element-422">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-423">
                <p className="font-semibold text-sm" data-id="element-424">Samantha Evans</p>
                <p className="text-sm text-gray-800" data-id="element-425">
                  Told all my coworkers about this. Everyone's switching over!
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-426">
                <span data-id="element-427">👍 37</span>
                <span data-id="element-428">3d</span>
              </div>
            </div>
          </div>

          {/* Comment 32 with reply */}
          <div className="flex gap-2" data-id="element-429">
            <img src="https://randomuser.me/api/portraits/men/12.jpg" alt="William Turner" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-430" />
            <div className="flex-1" data-id="element-431">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-432">
                <p className="font-semibold text-sm" data-id="element-433">William Turner</p>
                <p className="text-sm text-gray-800" data-id="element-434">
                  Is there a team plan? Want to get this for my whole company
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-435">
                <span data-id="element-436">👍 14</span>
                <span data-id="element-437">3d</span>
              </div>

              {/* Reply */}
              <div className="flex gap-2 mt-3 ml-6" data-id="element-438">
                <img src="https://randomuser.me/api/portraits/women/31.jpg" alt="Nicole Harris" className="w-7 h-7 rounded-full flex-shrink-0" data-id="element-439" />
                <div className="flex-1" data-id="element-440">
                  <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-441">
                    <p className="font-semibold text-xs" data-id="element-442">Nicole Harris</p>
                    <p className="text-xs text-gray-800" data-id="element-443">
                      Check their website, they have enterprise options!
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-444">
                    <span data-id="element-445">👍 8</span>
                    <span data-id="element-446">3d</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Comment 33 */}
          <div className="flex gap-2" data-id="element-447">
            <img src="https://randomuser.me/api/portraits/men/48.jpg" alt="Brandon Campbell" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-448" />
            <div className="flex-1" data-id="element-449">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-450">
                <p className="font-semibold text-sm" data-id="element-451">Brandon Campbell</p>
                <p className="text-sm text-gray-800" data-id="element-452">
                  This is the productivity boost I didn't know I needed 💪
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-453">
                <span data-id="element-454">👍 41</span>
                <span data-id="element-455">❤️ 12</span>
                <span data-id="element-456">3d</span>
              </div>
            </div>
          </div>

          {/* Comment 34 */}
          <div className="flex gap-2" data-id="element-457">
            <img src="https://randomuser.me/api/portraits/women/89.jpg" alt="Olivia Parker" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-458" />
            <div className="flex-1" data-id="element-459">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-460">
                <p className="font-semibold text-sm" data-id="element-461">Olivia Parker</p>
                <p className="text-sm text-gray-800" data-id="element-462">
                  Can't believe how much time this saves me. Worth every penny!
                  ⭐
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-463">
                <span data-id="element-464">👍 48</span>
                <span data-id="element-465">3d</span>
              </div>
            </div>
          </div>

          {/* Comment 35 */}
          <div className="flex gap-2" data-id="element-466">
            <img src="https://randomuser.me/api/portraits/men/60.jpg" alt="Eric Collins" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-467" />
            <div className="flex-1" data-id="element-468">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-469">
                <p className="font-semibold text-sm" data-id="element-470">Eric Collins</p>
                <p className="text-sm text-gray-800" data-id="element-471">
                  The future is here and it's called HEYLLOYD. Get it before the
                  price goes up! 🔥
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-472">
                <span data-id="element-473">👍 63</span>
                <span data-id="element-474">❤️ 24</span>
                <span data-id="element-475">3d</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>;
}